export const withEmptyOption = (optionList: string[] | undefined): string[] => {
  if (optionList) {
    if (optionList.length > 0) {
      return ['', ...optionList];
    }
  }

  return [];
};
